var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-fullheight"},[_c('div',{staticClass:"hero-body"},[_c('main',{staticClass:"hero-body--wrapper"},[_c('TheHeader'),_c('div',{staticClass:"is-flex"},[_c('router-view')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }